/**
 * Module dependencies.
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names, resolving conflicts (shadcn `cn` helper).
 */

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
